module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAALxJREFUSEvN1m0KgCAMBmB3jqDuVYepLtPBAs9hGBilzm05rH4WvI8fcwb9aGcAszhnln3rVqP03HNhmKwLuVpQAEIuxC9qoVweeE0LwnJORAMqDfRCaiBqJR7IG4gCfGaCSCAOgCIciAsUkRIkAUgEg3yHkBzg7J7EnSUeuQRgzUTjHP1jJtlepLknWBWpVRcVRH2/F883J14yQk5nSEpYCnDLu9198nYGVGcIV3mbO77p30rtXwq2dD73AJLgL1WGB80MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/close_blue.png
// module id = mjJ5
// module chunks = 84